(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dm-caddy-upsell"] && !Shopify.designMode) return;
  try {
    const dmCaddyDialog = document.querySelector('[data-dm-caddy-upsell]');

  if (dmCaddyDialog && dmCaddyDialog.dataset.initialized !== 'true') {
    dmCaddyDialog.dataset.initialized = 'true';

    const eligibleProductIds = new Set(
      dmCaddyDialog.dataset.eligibleProductIds.split(',').map((id) => Number(id))
    );
    const towelProductId = Number(dmCaddyDialog.dataset.towelProductId);
    const towelVariantId = Number(dmCaddyDialog.dataset.towelVariantId);
    const cartRoot = window.Shopify?.routes?.root || dmCaddyDialog.dataset.cartRoot || '/';
    const cartUrl = dmCaddyDialog.dataset.cartUrl || `${cartRoot}cart`;
    const addButton = dmCaddyDialog.querySelector('[data-dm-caddy-add]');
    const closeButtons = dmCaddyDialog.querySelectorAll('[data-dm-caddy-close]');
    const status = dmCaddyDialog.querySelector('[data-dm-caddy-status]');
    const originalButtonLabel = addButton.textContent.trim();
    const nativeFetch = window.fetch.bind(window);
    let checkTimer;
    let checkInProgress = false;
    let addingTowel = false;

    const storageGet = (key) => {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const storageSet = (key, value) => {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        return;
      }
    };

    const storageRemove = (key) => {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {
        return;
      }
    };

    const getCart = async () => {
      const response = await nativeFetch(`${cartRoot}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Cart unavailable');
      }

      return response.json();
    };

    const getEligibleQuantity = (cart) =>
      cart.items.reduce((quantity, item) => {
        if (eligibleProductIds.has(Number(item.product_id))) {
          return quantity + item.quantity;
        }

        return quantity;
      }, 0);

    const getStorageKey = (cart) => `dm-caddy-upsell:${cart.token || 'current-cart'}`;

    const checkCart = async () => {
      if (checkInProgress || addingTowel) {
        return;
      }

      checkInProgress = true;

      try {
        const cart = await getCart();
        const storageKey = getStorageKey(cart);
        const eligibleQuantity = getEligibleQuantity(cart);
        const towelInCart = cart.items.some((item) => Number(item.product_id) === towelProductId);

        if (eligibleQuantity === 0) {
          storageRemove(storageKey);
        }

        if (
          eligibleQuantity >= 2 &&
          !towelInCart &&
          !storageGet(storageKey) &&
          !dmCaddyDialog.open
        ) {
          dmCaddyDialog.showModal();
          storageSet(storageKey, 'shown');
        }
      } catch (error) {
        return;
      } finally {
        checkInProgress = false;
      }
    };

    const scheduleCartCheck = (delay = 180) => {
      window.clearTimeout(checkTimer);
      checkTimer = window.setTimeout(checkCart, delay);
    };

    const requestUrl = (input) => {
      if (typeof input === 'string') {
        return input;
      }

      return input?.url || '';
    };

    window.fetch = async (...args) => {
      const response = await nativeFetch(...args);
      const url = requestUrl(args[0]);

      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
        scheduleCartCheck();
      }

      return response;
    };

    const closeDialog = () => {
      if (dmCaddyDialog.open) {
        dmCaddyDialog.close();
      }
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeDialog);
    });

    dmCaddyDialog.addEventListener('click', (event) => {
      if (event.target === dmCaddyDialog) {
        closeDialog();
      }
    });

    addButton.addEventListener('click', async () => {
      if (addingTowel) {
        return;
      }

      addingTowel = true;
      addButton.disabled = true;
      addButton.textContent = dmCaddyDialog.dataset.addingLabel;
      status.textContent = '';

      try {
        const latestCart = await getCart();
        const stillEligible = getEligibleQuantity(latestCart) >= 2;
        const towelAlreadyInCart = latestCart.items.some(
          (item) => Number(item.product_id) === towelProductId
        );

        if (!stillEligible || towelAlreadyInCart) {
          addingTowel = false;
          addButton.disabled = false;
          addButton.textContent = originalButtonLabel;
          closeDialog();
          scheduleCartCheck();
          return;
        }

        const response = await nativeFetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: towelVariantId, quantity: 1 }],
          }),
        });

        if (!response.ok) {
          throw new Error('Unable to add towel');
        }

        addButton.textContent = dmCaddyDialog.dataset.addedLabel;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.setTimeout(() => window.location.assign(cartUrl), 350);
      } catch (error) {
        addingTowel = false;
        addButton.disabled = false;
        addButton.textContent = originalButtonLabel;
        status.textContent = dmCaddyDialog.dataset.errorLabel;
      }
    });

    document.addEventListener('cart:updated', () => scheduleCartCheck());
    document.addEventListener('cart:refresh', () => scheduleCartCheck());
    document.addEventListener('product:added', () => scheduleCartCheck());
    window.addEventListener('pageshow', () => scheduleCartCheck(500));
    window.addEventListener('focus', () => scheduleCartCheck(250));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        scheduleCartCheck(250);
      }
    });

    scheduleCartCheck(650);
  }
  } catch(e) { console.error(e); }
})();

})();
